<div class="row">
    @if(loading) {
        <div class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="text-muted mt-2">Loading release information...</p>
        </div>
    }
    @if (!loading) {
       @for (release of releases; track $index) {
        <div class="col-md-6 mb-4">
          <div class="card shadow-sm">
              <div class="card-header bg-primary text-white">
                  <h5 class="mb-0 fw-bold">Hello Captain — {{ release.label }}</h5>
              </div>
              <div class="card-body p-4">
                  <div class="mb-3">
                      <h6 class="fw-bold mb-0">Release Version</h6>
                      <p class="card-text fs-5">{{ release.version }}</p>
                  </div>
                  <div class="mb-3">
                      <h6 class="fw-bold mb-0">Release Date</h6>
                      <p class="card-text fs-5">{{ release.releaseDate | date: 'MMMM dd, yyyy' }}</p>
                  </div>
                  <div class="mb-4">
                      <h6 class="fw-bold mb-0">Download</h6>
                      <p class="card-text fs-6">
                          <a [href]="release.downloadUrl" target="_blank" rel="noopener noreferrer">
                              <i class="fas fa-download me-1"></i>
                              Download Page
                          </a>
                      </p>
                  </div>
                  <div class="text-end">
                      <button mat-raised-button color="primary" (click)="copyLinkToClipboard(release.downloadUrl)">
                          <i class="fas fa-copy me-2"></i>
                          Copy Download Link
                      </button>
                  </div>
              </div>
          </div>
        </div>
       }
    }
</div>
